<template>
  <label
    :class="[
      'cust-item d-flex align-items-start jcsb',
      isSelected ? 'border-teal' : '',
    ]"
    :for="generateUniqueId(label)"
    :key="generateUniqueId(label)"
  >
    <span class="d-flex align-items-start">
      <i
        class="mr8 mt3"
        :class="[dietType == 'veg' ? 'tag-veg' : 'tag-non-veg']"
      ></i>
      <span class="labl-txt fs-14">{{ label || "" }}</span>
    </span>
    <span class="d-flex align-items-center">
      <span class="fs-14 color-slaty ib nowrap" v-if="itemPrice"
        ><span v-if="!isCustomisable">+ </span><span class="rs">Rs.</span
        >{{ itemPrice }}
      </span>

      <!-- Radio ui -->
      <div class="checkbox-wrapper ml10">
        <label class="checkbox">
          <input
            type="checkbox"
            :id="generateUniqueId(label)"
            :name="urlifyName(checkboxName)"
            :value="value"
            :checked="isSelected"
            @change="inputFun"
          />
          <i></i>
        </label>
      </div>
    </span>
  </label>
</template>

<script>
export default {
  name: "CustomLabelCheckbox",
  components: {
    //
  },

  data() {
    return {};
  },
  mounted() {},
  model: {
    prop: "value",
    event: ["checkboxHandler"],
  },
  methods: {
    inputFun(e) {
      this.$emit("checkboxHandler", {
        value: e.target._value,
        checked: e.currentTarget.checked,
      });
    },
    generateUniqueId(label) {
      return `${label.split(" ").join("-")}-${this.customIndex}`;
    },
    urlifyName(name) {
      return name.trim().split(" ").join("-");
    },
  },
  props: {
    label: { required: false, default: "" },
    customIndex: { required: false, default: "" },
    itemPrice: { required: false, default: "" },
    value: { required: false, default: "" },
    checkboxName: { required: false, default: "" },
    isSelected: { required: false, default: false },
    dietType: { required: false, default: "veg" },
    isCustomisable: { required: false, default: false },
  },
};
</script>
